import { HttpHeaders } from "@angular/common/http";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { AppSessionService } from "../app-session/app-session.service";

@Injectable({
  providedIn: "root",
})
export class TableConfigService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  getConfigSettings(code: string, settingType: string): Observable<any> {
    const headers = new HttpHeaders({ "Content-type": "application/json" });

    const url = `${this.appSession.baseUrl}/api/v1/settings/specific?code=${code}&settingType=${settingType}`;

    return this.http.get(url, { headers });
  }

  saveConfigSettings(config) {
    const headers = new HttpHeaders({ "Content-type": "application/json" });
    const data = JSON.stringify(config);

    const url = `${this.appSession.baseUrl + "/api/v1/settings"}`;

    return this.http.post(url, data, { headers });
  }
}
